import { useAtom } from "jotai/index";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import HhErrorsJournalModule from "@/module/hh-errors-journal-module/hh-errors-journal-module";
import { headerTitle } from "@/store/store";

const HhErrorsJournalPage = () => {
  const { t } = useTranslation();
  const [, setHeaderTitle] = useAtom(headerTitle);

  useEffect(() => {
    setHeaderTitle(t("hhErrorsJournal"));
  }, [setHeaderTitle, t]);

  return <HhErrorsJournalModule />;
};

export default HhErrorsJournalPage;
